import React from 'react'
import Header from '../components/Home/Header'
import SidebarPopup from '../components/Home/SidebarPopup'
import Preloader from '../components/Home/Preloader'
import Slider from '../components/Home/Slider'
import Book from '../components/Home/Book'
import AboutArea from '../components/Home/AboutArea'
import DownloadApp from '../components/Home/DownloadApp'
import OurAwesomeFeature from '../components/Home/OurAwesomeFeature'

const Home = () => {
  return (
    <div>
    
      {/* <Preloader /> */}
      {/* <Header /> */}
      <SidebarPopup />

      <main class="main">
        <Slider />
        <Book />
        <OurAwesomeFeature />
        <DownloadApp />
        <AboutArea />
      </main>
    </div>
  )
}

export default Home
